module.exports = __webpack_public_path__ + "img/bg-medium.9e283c2c.svg";